import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";

export default function TextField({ id, label, value, onChange, type = "text", multiline = false, required = true, placeholder = "" }) {
  const Control = multiline ? Textarea : Input;
  return (
    <div className="grid gap-2">
      <Label htmlFor={id} className="text-xs font-bold uppercase tracking-[0.16em] text-[#475569]" data-testid={`${id}-label`}>
        {label}
      </Label>
      <Control
        id={id}
        name={id}
        type={type}
        value={value}
        onChange={onChange}
        required={required}
        placeholder={placeholder}
        data-testid={`${id}-input`}
        className="min-h-11 rounded-sm border-[#CBD5E1] bg-white text-[#0B1120] focus-visible:ring-[#0066FF]"
      />
    </div>
  );
}